module.exports = __webpack_public_path__ + "static/media/receta-04.c9970b60.png";